import { createAction, createAsyncThunk, createReducer } from '@reduxjs/toolkit';
import { API, SCOPE_CRM_AUDIT } from '../../constants';
import { application } from '../../services/application';
import { getFilterParams } from '../../utils/filterUtils';
import { INITIAL_LIST_STATE_EXTENDED } from '../helpers/common';
import { extendListBuilder, generateListActions } from '../helpers/listActionsHelpers';
import { extendBuilderWithFacetCounts, extendBuilderWithListControls } from '../helpers/sharedCases';

export const AUDIT_FIELD_FILTER_KEYS = ['activityType', 'userId', 'createdAt'];

export const INITIAL_STATE = {
  ...INITIAL_LIST_STATE_EXTENDED,
  order: ['createdAt', 'desc'],
  pagination: { page: 1, perPage: 20 },
  params: {},
  facetCounts: null,
  facetCountsPending: false,
  facetCountsRequestId: null,
};

const listActions = generateListActions({
  scope: SCOPE_CRM_AUDIT,
  apiMethod: {
    GET_LIST: API.CRM_AUDIT.GET_LIST,
  },
  getStore: (store) => store.crmAudit,
});

export const setAuditListFilters = createAction(`${SCOPE_CRM_AUDIT}/setAuditListFilters`);
export const setAuditListOrder = createAction(`${SCOPE_CRM_AUDIT}/setAuditListOrder`);

export const fetchFacetCounts = createAsyncThunk(`${SCOPE_CRM_AUDIT}/fetchFacetCounts`, (_, { getState }) => {
  const { text, fields } = getState().crmAudit.filters;

  return application.call(API.CRM_AUDIT.GET_FACET_COUNTS, {
    text: text || '',
    filters: getFilterParams(fields),
  });
});

export const actions = {
  ...listActions,
  setAuditListFilters,
  setAuditListOrder,
  fetchFacetCounts,
};

export default createReducer(INITIAL_STATE, (builder) => {
  extendListBuilder(builder, actions);
  extendBuilderWithListControls(
    builder,
    { setFilters: setAuditListFilters, setOrder: setAuditListOrder },
    AUDIT_FIELD_FILTER_KEYS
  );
  extendBuilderWithFacetCounts(builder, fetchFacetCounts);
});
